<template>
  <div
    class="lv-tabs"
    :class="[styleType]"
  >
    <WsRow class="ma-0 lv-tabs__nav">
      <WsCol
        :cols="_moreItems && _moreItems.length?10:12"
        :mdcols="_moreItems && _moreItems.length?10:12"
        :smcols="_moreItems && _moreItems.length?10:12"
        class="pa-0 w-full lv-tabs__navbar"
      >
        <WsFlex
          ref="container"
          class="lv-tabs__navbar-content"
        >
          <div
            v-for="(item, itemIndex) in items"
            :key="itemIndex"
            ref="refItem"
            :class="[
              { active: C_value === item.id },
              { hide: !$_isItemDisplay(itemIndex)},
              { disabled: isDisabled},
              { loading: item.isLoading},
            ]"
            class="lv-tabs__navbar-item"
            :style="{'min-width':minWidth+'px'}"
            @click="$_onClick(item)"
          >
            {{ $t(item.textLabel) }}
            <WsLoading v-if="isLoading" primary class="ml-8"/>
            <p v-else-if="item.num" class="num">
              {{item.num}}
            </p>
          </div>
        </WsFlex>
      </WsCol>
      <WsCol
        v-if="_moreItems && _moreItems.length"
        :cols="2"
        :mdcols="2"
        :smcols="2"
        class="lv-tabs__navbar-more"
      >
        <div
          v-click-outside="$_onCloseMoreItems"
          class="lv-tabs__navbar-more"
        >
          <h4
            class="lv-tabs__navbar-more__head"
            @click.stop="$_onToggleMoreItems()"
          >
            <span class="sm-hide">{{ _moreText }}</span>
            <i class="icon-chevron-down" />
          </h4>
          <ul
            class="lv-tabs__navbar-more__body"
            :class="{show: isActive.moreItems}"
          >
            <li
              v-for="item in _moreItems"
              :key="item.id"
              :class="{ active: C_value === item.id }"
              class="lv-tabs__navbar-more__body__list"
              @click="$_onClickMoreItems(item)"
            >
              <p>{{ item.textLabel }}</p>
            </li>
          </ul>
        </div>
      </WsCol>
    </WsRow>
  </div>
</template>

<script>
export default {
  props: {
    keepPosition: {
      type: Boolean,
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: [String, Number],
    },
    styleType: {
      type: String,
    },
    name: {
      type: String,
    },
    isQueryState: {
      type: Boolean,
      default: false,
    },
    emitToQuery: {
      type: Boolean,
      default: false,
    },
    getReplaceQuery: {
      type: Function,
    },
    minWidth: {
      type: Number,
      default: 140,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      container: {},
      refItem: [],
      C_value: '',
      isActive: {
        moreItems: false,
      },
      debouncedInit: null,
    };
  },
  computed: {
    _moreItems() {
      if (!this.refItem.length) {
        return [];
      }
      const _moreItems = [];
      this.items.forEach((item, itemIndex) => {
        if (!this.$_isItemDisplay(itemIndex)) {
          _moreItems.push(item);
        }
      });
      return _moreItems;
    },
    _moreText() {
      let itemLabel = '';
      this._moreItems.forEach((item) => {
        if (item.id === this.C_value) {
          itemLabel = item.label;
        }
      });
      if (!itemLabel) {
        return this.$t('顯示更多');
      } else {
        return itemLabel;
      }
    },
  },
  watch: {
    value: {
      handler() {
        this.$_setValue();
      },
    },
    $route: {
      handler() {
        this.$_setValue();
      },
      deep: true,
    },
    items: {
      handler() {
        this.debouncedInit();
      },
      deep: true,
    },
  },
  mounted() {
    this.$_setValue();
    this.debouncedInit();
    setTimeout(() => {
      this.$nextTick(() => {
        if (!this.$refs.container || !this.items || !this.items.length) return;
        this.container = {
          clientWidth: this.$refs.container.$el.clientWidth,
        };
        this.refItem = [...this.$refs.refItem];
      });
    }, 0);
  },
  created() {
    this.debouncedInit = this.$_debounce(this.$_init, 200);
    window.addEventListener('resize', this.debouncedInit);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.debouncedInit);
  },
  methods: {
    $_debounce(fn, delay) {
      let timer = null;
      return function() {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
          fn.apply(this, arguments);
        }, delay);
      };
    },
    $_onCloseMoreItems() {
      this.isActive.moreItems = false;
    },
    $_isItemDisplay(itemIndex) {
      if (!this.refItem[itemIndex]) {
        return true;
      }
      const itemWidthFromLeft = this.$_getItemWidthFromLeft(itemIndex);
      if (itemWidthFromLeft > this.container.clientWidth) {
        return false;
      }
      return true;
    },
    $_getItemWidthFromLeft(itemIndex) {
      let itemWidthFromLeft = 0;
      for (let index = 0; index < itemIndex + 1; index++) {
        itemWidthFromLeft += this.refItem[index].clientWidth;
      }
      return itemWidthFromLeft;
    },
    $_init() {
      setTimeout(() => {
        this.$nextTick(() => {
          if (!this.$refs.container || !this.items || !this.items.length) return;
          this.container = {
            clientWidth: this.$refs.container.$el.clientWidth,
          };
          this.refItem = [...this.$refs.refItem];
        });
      }, 0);
    },
    $_setValue() {
      if (this.isQueryState && !this.value) {
        this.C_value = this.$route.query[this.name];
      } else {
        this.C_value = this.value;
      }
    },
    $_onClick(item) {
      if (this.isDisabled) return;
      const _tab = item;
      this.$emit('input', _tab);
      if (this.isQueryState && this.emitToQuery) {
        let _query = {
          ...this.$route.query,
          [this.name]: item.id,
        };
        if (this.getReplaceQuery) {
          _query = this.getReplaceQuery(_query);
        }
        if (this.keepPosition) {
          _query.keep_position = 1;
        }
        this.$router
          .replace({
            name: this.$route.name,
            query: _query,
          })
          .catch(() => {});
      }
    },
    $_onClickMoreItems(item) {
      this.isActive.moreItems = false;
      this.$_onClick(item);
    },
    $_onToggleMoreItems() {
      this.isActive.moreItems = !this.isActive.moreItems;
    },
  },
};
</script>